import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import ViewCounter from "./ViewCounter";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { counterApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function PublishCounter(props) {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const { id } = useParams();
  const [counter, setCounter] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  useEffect(() => {
    counterApi
      .get("/Counters/" + id, {
        signal: source.current.signal
      })
      .then(data => setCounter(data))
      .catch(error => console.log(error));
  }, [id]);

  const [disabled, setDisabled] = React.useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    counterApi
      .post(
        "/Counters/Publish",
        {
          id: id
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to="/admin/Counters/InDraft" />
  ) : (
    counter !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>PUBLISH COUNTER</h4>
            </CardHeader>
            <CardBody>
              <i>
                *Please review the Counter Information before publish it. Once
                it is published, it cannot be reverted.
              </i>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  Cancel
                </Button>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                >
                  PUBLISH
                </Button>
              </form>
              <ViewCounter counter={counter} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

PublishCounter.propTypes = {
  history: PropTypes.object
};
